(function ($, GetPageTemplate) {
    // k0=0(0 - not agree, 1 - agree)&k1=FullTextPTName&k2=DateTime UTC
    var getCustomerConsented = function () {
        var csCookie = (' ' + document.cookie).match(/[; ]cs=([^\s;]*)/i);
        var data = {
            k0: 0,
            k1: null,
            k2: null
        };

        if (csCookie && csCookie[1]) {
            var csValue = csCookie[1].split('&');
            for (var i = 0; i < csValue.length; i++) {
                var keyValue = csValue[i].split('=');
                var key = keyValue[0];
                var value = keyValue[1];
                data[key] !== undefined && (data[key] = value);
            }
        }

        return data;
    };

    var displaySoftPopup = function (ptName) {
        return $.tmpl('consent-block-popup-soft', { Text: GetPageTemplate(ptName), ContinueText: GetPageTemplate('_consentContinueText') }).prependTo('body');
    }

    var displayStrictPopup = function (ptName) {


        var html1 = GetPageTemplate('ConsentShortText_Page1');

        var $el = $.tmpl('consent-block-popup-strict', { Html1: html1, ContinueText: GetPageTemplate('_consentContinueText') }).appendTo('body');
        $('@html1-link', $el).on('click', function () {
            $('@html1', $el).addClass('hidden-block');
            $('@html2', $el).removeClass('hidden-block');
        });
        $('@html2-link', $el).on('click', function () {
            $('@html2', $el).addClass('hidden-block');
            $('@html1', $el).removeClass('hidden-block');
        });

        api.getDataPrivacyPolicyHtml({ hideErrors: true })
            .done(function (data) {
                if (data && data.Result) {
                    $('@html2-text', $el).html(data.Value);
                }
            })


        return $el;
    }

    var subscribeOn = function ($el) {
        $('@consent-continue-button').on('click', function () {
            api.saveConsentData({ hideErrors: true }).done(function (data) {
                data.Result && $el.remove();
            });
        });
    }

    $(function () {
        var isConsentPage = location.href.match(/DataPrivacyPolicy\.aspx/i) !== null;
        var settings = $('[id$="siteData"]').data('consent');
        var csCookie = getCustomerConsented();
        var $consentContinueButton = $('@consent-continue-button');

        if (settings.Mode !== 0) {
            if (csCookie.k0 != 0) {
                csCookie.k1 !== settings.FullTextPTName && (csCookie.k0 = 0);
            }

            if (csCookie.k0 === 0) {
                api.getConsentData({ hideErrors: true })
                    .done(function (data) {
                        if (!data || !data.Value || data.Value.ShowConsentRequired === undefined) {
                            data = { Value: { ShowConsentRequired: true } };
                        }

                        if (isConsentPage) {
                            if (data.Value.ShowConsentRequired) {
                                subscribeOn($consentContinueButton);
                            } else {
                                $consentContinueButton.remove()
                            }
                        } else if (data.Value.ShowConsentRequired) {
                            settings.Mode === 1 && subscribeOn(displaySoftPopup(settings.ShortTextPTName));
                            settings.Mode === 2 && subscribeOn(displayStrictPopup(settings.ShortTextPTName));
                        }
                    });
            } else {
                $consentContinueButton.remove()
            }
        } else {
            $consentContinueButton.remove()
        }
    });

})(jQuery, window.PageTemplates && window.PageTemplates.get || window.GetPageTemplate || kos.getPageTemplate);